module.exports=[
  {
    "position": "guidance counselor",
    "number of students to generate one staff": 236,
    "percentage": 376.69,
    "text": "three guidance counselors — who often end up <a href=\"https://www.seattletimes.com/education-lab/why-are-washingtons-school-counselors-monitoring-recess/\">taking on other roles</a> — and 77% of a fourth"
  },
  {
    "position": "school nurses",
    "number of students to generate one staff": "6,250.00",
    "percentage": 14.22,
    "text": "14% of a school nurse"
  },
  {
    "position": "social workers",
    "number of students to generate one staff": "40,000.00",
    "percentage": 2.22,
    "text": "2% of a social worker"
  },
  {
    "position": "psychologists",
    "number of students to generate one staff": "85,714.00",
    "percentage": 1.04,
    "text": "1% of a psychologist"
  }
]